import { render, staticRenderFns } from "./UpdateMerchantRewards.vue?vue&type=template&id=cba48658&"
import script from "./UpdateMerchantRewards.vue?vue&type=script&lang=js&"
export * from "./UpdateMerchantRewards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports